import React from 'react';
import {
    CONTRACT_STATE_SIGNED,
    CONTRACT_STATE_SENT,
    CONTRACT_STATE_DRAFT,
    CONTRACT_STATE_FEEDBACK,
    CONTRACT_STATE_SENT_DRAFT,
    CONTRACT_STATE_NOT_FOUND
} from '../../../constants/settings';

const STATE_TEXTS = {
    [CONTRACT_STATE_FEEDBACK]: 'Sent back',
    [CONTRACT_STATE_SENT]: 'Ready for signing',
    [CONTRACT_STATE_NOT_FOUND]: 'No contract found',
    [CONTRACT_STATE_SENT_DRAFT]: 'Ready for signing (Draft)',
    [CONTRACT_STATE_SIGNED]: 'Signed',
    [CONTRACT_STATE_DRAFT]: 'Draft'
};
const SignState = ({ state }) => (
    <span className={`ckp-contracts-inbox-state is-${state}`}>{STATE_TEXTS[state] || state}</span>
);

export default SignState;



// WEBPACK FOOTER //
// ./src/components/application/contracts/SignState.js